/** Configuração declarativa da sidebar (layout). */
export const SIDEBAR_UI_CONFIG = {
  header: {
    homeHref: "/",
    logoAlt: "TREND Logo",
    logoNavigateLabel: "Ir para a página inicial",
    expandedLogoButton:
      "cursor-pointer border-0 bg-transparent p-0 transition-opacity hover:opacity-90",
    expandedLogoImage: "h-12 w-auto object-contain",
    collapsedLogoImage: "h-12 w-auto object-contain transition-opacity",
  },
};
